__turbopack_context__.v({
  "arrow": "ParticipationSteps-module-scss-module__P9vb8G__arrow",
  "arrowBounce": "ParticipationSteps-module-scss-module__P9vb8G__arrowBounce",
  "iconPulse": "ParticipationSteps-module-scss-module__P9vb8G__iconPulse",
  "stepIcon": "ParticipationSteps-module-scss-module__P9vb8G__stepIcon",
});
